// extracted by mini-css-extract-plugin
export default {"positive":"Ey1xAfoFV_HNxOzANT3I","negative":"I88dCEwIvpdH_a8mT3hJ"};